/**
 * The match's rulebook, for the scorer's screen: which dismissals stand on
 * this ball (wide / no-ball / free hit). A copy of dismissal_check in
 * backend/services/scoring_rules.py, only to grey out choices — the server
 * decides every ball.
 */
const DEFAULT_ALLOWED = { wide: ['stumped', 'run_out'], no_ball: ['run_out'], free_hit: ['run_out', 'obstructing'] };
const WORDS = {
  stumped: 'Stumping', lbw: 'LBW', hit_wicket: 'Hit wicket', run_out: 'Run out', caught: 'Caught', bowled: 'Bowled',
  obstructing: 'Obstructing', retired_hurt: 'Retired hurt', retired_out: 'Retired out',
};
const WHEN = { wide: 'a wide', no_ball: 'a no-ball', free_hit: 'a free hit' };

/** {ok, reason} for a dismissal in these situations under the match's rules. */
export function wicketAllowed(rules, situations, type) {
  if (['retired_hurt', 'retired_out'].includes(type)) return { ok: true };
  let ok = true;
  let reason = null;
  const law = situations.find((s) => DEFAULT_ALLOWED[s] && !DEFAULT_ALLOWED[s].includes(type));
  if (law) { ok = false; reason = `Not out on ${WHEN[law]}`; }
  (rules?.dismissals || []).forEach((d) => {
    const hits = d.dismissal === type || (d.dismissal === 'any_except_run_out' && type !== 'run_out');
    if (!hits) return;
    if (d.when?.length && !d.when.some((w) => situations.includes(w))) return;
    if (d.result === 'not_allowed' || d.result === 'not_out') {
      ok = false;
      reason = `${d.result === 'not_allowed' ? 'Not allowed' : 'Not out'}${d.when?.length ? ` on ${d.when.map((w) => WHEN[w]).join(' or ')}` : ''} (rulebook)`;
    } else if (d.result === 'out') {
      ok = true;
      reason = d.penalty_runs ? `Out, −${d.penalty_runs} runs (rulebook)` : null;
    }
  });
  return { ok, reason, label: WORDS[type] || type };
}

/** "Power ball ×2 +6" for an effect chip. */
export const effectText = (e) => (e.runs ? `${e.text} ${e.runs > 0 ? '+' : '−'}${Math.abs(e.runs)}` : e.text);
